import { render, staticRenderFns } from "./upload_page.vue?vue&type=template&id=40c24ae5&scoped=true&"
import script from "./upload_page.vue?vue&type=script&lang=js&"
export * from "./upload_page.vue?vue&type=script&lang=js&"
import style0 from "./upload_page.vue?vue&type=style&index=0&id=40c24ae5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c24ae5",
  null
  
)

export default component.exports